// extracted by mini-css-extract-plugin
export default {"title":"i--z","warning":"j--z","sizeOptionsLegendText":"k--z"};